"use client";
import React from "react";
import Home from "../../components/home/Home";

export default function Homepage() {
  return <Home />;
}
